exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sigma-iframe{min-width:100%;min-height:80vh;border:none;margin-left:-1.5rem}", ""]);

// exports
